var map = {
	"./adult1.inline.svg": 13960,
	"./appercot.svg": 4031,
	"./architectureicon.inline.svg": 49188,
	"./atoms_title.svg": 45114,
	"./audit.inline.svg": 64609,
	"./baby1.inline.svg": 77966,
	"./brandbook.inline.svg": 70146,
	"./branding1.inline.svg": 43026,
	"./chaticon1.inline.svg": 39867,
	"./designsystemicon.inline.svg": 96518,
	"./discoveryandresearchicon01.inline.svg": 69988,
	"./documenticon.inline.svg": 26963,
	"./expertreview.inline.svg": 37442,
	"./gfgsfgfs-1.svg": 55374,
	"./illustrations.inline.svg": 68977,
	"./logo.inline.svg": 99822,
	"./logo_free-ukraine.svg": 63358,
	"./migis.svg": 4654,
	"./mobileappicon.inline.svg": 98645,
	"./mobileappicon.svg": 1841,
	"./responsive.inline.svg": 22320,
	"./rocketicon01.inline.svg": 50771,
	"./sass.inline.svg": 9823,
	"./uxdesignicon01.inline.svg": 32818,
	"./uxstrategyandideationicon01.inline.svg": 88426,
	"./web.inline.svg": 37611,
	"./yangol.svg": 99485
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 80980;